export default __webpack_public_path__ + "static/media/HHGBrandLogo2.c1fa88ba.svg";